import styled from 'styled-components';
import { Paper } from '@ui';

export const OnboardingLayoutSC = styled(Paper)`
  min-height: 100vh;
  width: 100vw;
  padding-bottom: 64px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: ${({ theme }) => theme.shadows.medium};
`;

export const ContentSC = styled(Paper)`
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 40px;
  margin-top: 124px;
`;

export const FooterSC = styled.div`
  margin: 0 auto;
  margin-top: 40px;

  width: 100%;
  max-width: 680px;
`;
